export class NavigationItemModel {
  model = {};

  constructor(storeKey?: string, icon?: string, label?: string, path?: string) {
    if (path) this.setNavigationPath(path);

    if (storeKey) this.setStoreKey(storeKey);

    if (icon) this.setIconName(icon);

    if (label) this.setLabel(label);
  }

  /**
   * Return navigation path
   * @returns {string}
   */
  navigationPath() {
    return this.model["routePath"];
  }

  /**
   * Return boolean response whether route is needed
   * @returns {boolean}
   */
  isNavigationNeeded() {
    return this.model["routePath"] ? true : false;
  }

  /**
   * Assign Navigation path for item
   * @param path
   */
  setNavigationPath(path) {
    this.model["routePath"] = path;
    return this;
  }

  /**
   * Assign Store key for Library.store.ts
   * @param key
   */
  setStoreKey(key) {
    this.model["storeKey"] = key;
    return this;
  }

  /**
   * Return store key
   * @returns {any}
   */
  storeKey() {
    return this.model["storeKey"];
  }

  /**
   * Assign icon name
   * @param icon
   * @return void
   */
  setIconName(icon) {
    this.model["icon"] = icon;
    return this;
  }

  /**
   * Return icon name
   * @returns {any}
   */
  icon() {
    return this.model["icon"];
  }

  /**
   * Assign label
   * @param label
   * @returns {NavigationItemModel}
   */
  setLabel(label) {
    this.model["label"] = label;
    return this;
  }

  /**
   * Return the required label
   * @returns {any}
   */
  label(capitalize) {
    if (
      typeof this.model["label"] == "undefined" ||
      this.model["label"] == null
    )
      return "";

    return capitalize ? this.model["label"].toUpperCase() : this.model["label"];
  }
}
